import React from 'react';

// A beige form card for the dark-page builders. `data-paper="beige"` retints the
// shadcn Input/Textarea/Select inside to white-on-beige (see index.css). Fields
// use builderLabelStyle for the mono kicker labels.
export const builderLabelStyle: React.CSSProperties = {
  fontSize: 10,
  fontWeight: 500,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: 'var(--hj-beige-ink)',
  fontFamily: 'var(--hj-font-mono)',
  display: 'block',
  marginBottom: 6,
};

export const builderErrorStyle: React.CSSProperties = {
  marginTop: 4,
  fontSize: 11,
  color: 'hsl(var(--destructive))',
};

export const builderHelpStyle: React.CSSProperties = {
  marginTop: 5,
  fontSize: 11.5,
  color: 'var(--hj-beige-ink-3)',
  lineHeight: 1.5,
};

export function BuilderCard({
  kicker,
  children,
  style,
}: {
  kicker?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div
      data-paper="beige"
      className="flex flex-col gap-4"
      style={{
        padding: 20,
        borderRadius: 'var(--hj-r-md)',
        background: 'var(--hj-beige)',
        border: '1px solid var(--hj-beige-line)',
        color: 'var(--hj-beige-ink)',
        ...style,
      }}
    >
      {kicker && <div className="mono-label" style={{ color: 'var(--hj-beige-ink-3)' }}>{kicker}</div>}
      {children}
    </div>
  );
}
